import type { Locale } from "./messages";

export type PluralCategory = "one" | "few" | "many" | "other";

/** The CLDR plural category a count takes in the locale ("4 записи"). */
export function pluralCategory(locale: Locale, count: number): PluralCategory {
  const category = new Intl.PluralRules(locale).select(count);
  return category === "one" || category === "few" || category === "many"
    ? category
    : "other";
}

/** "вчера", "3 дня назад": whole days between two instants, in the locale. */
export function daysAgo(locale: Locale, then: Date, now: Date = new Date()) {
  const day = (value: Date) =>
    Date.UTC(value.getFullYear(), value.getMonth(), value.getDate());
  const days = Math.round((day(now) - day(then)) / 86_400_000);
  return new Intl.RelativeTimeFormat(locale, { numeric: "auto" }).format(
    -days,
    "day",
  );
}
